module.exports = __webpack_public_path__ + "static/media/needs_triangle.80fc29d3.jpg";